<template>
  <div class="splash-page">
    <div class="c-responsive-fixwidth">
      <div class="o-main-content-area">
        <div class="col-md-12 o-no-padding c-common-box-shadow u-bg-color-fff" style="padding: 20px !important;">

          <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-6">
              <h3>Login Page Splash Message</h3>
            </div>
            <div class="col-md-6 text-right">
              <button class="c-solid-btn c-solid-btn--green" @click="saveMessage" :disabled="saving">
                <i class="fa fa-floppy-o" aria-hidden="true"></i> Save
              </button>
            </div>
          </div>

          <!-- Power User Access (client-admin only) -->
          <div v-if="userRoleSlug === 'client-admin'" class="row" style="margin-bottom: 20px;">
            <div class="col-md-12">
              <label style="margin-bottom: 8px; display: block;">Power Users allowed to edit this page:</label>
              <el-select
                v-model="selectedEditors"
                multiple
                filterable
                placeholder="Select power users..."
                style="width: 100%;"
                @change="saveEditors"
              >
                <el-option
                  v-for="pu in powerUsers"
                  :key="pu.id"
                  :label="pu.first_name + ' ' + pu.last_name"
                  :value="pu.id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- CKEditor -->
          <div class="row">
            <div class="col-md-12">
              <textarea id="splash-editor" name="splash-editor" style="width: 100%; min-height: 300px;"></textarea>
            </div>
          </div>

          <!-- Preview -->
          <div class="row" style="margin-top: 20px;">
            <div class="col-md-12">
              <h5 style="margin-bottom: 10px;">Preview (as seen on login page):</h5>
              <div class="splash-preview" v-html="previewHtml"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '../services.js';

export default {
  name: 'SplashPage',
  data() {
    return {
      client: null,
      powerUsers: [],
      selectedEditors: [],
      saving: false,
      editorInstance: null,
      previewHtml: ''
    };
  },
  computed: {
    ...mapGetters({
      userToken: 'userToken',
      userRole: 'userRole',
      userClientID: 'userClientID',
      employeeId: 'employeeId',
      userRoleSlug: 'userRoleSlug'
    })
  },
  methods: {
    async loadClient() {
      try {
        var res = await service.get('client/' + this.userClientID, {
          'Authorization': this.userToken
        });
        this.client = res.data.result;
        var msg = this.client.login_page_message || '';
        this.previewHtml = msg;

        // Load saved editors from settings
        if (this.client.settings && this.client.settings['splash-editors']) {
          this.selectedEditors = this.client.settings['splash-editors'];
        }

        // Set editor content after CKEditor is ready
        var self = this;
        if (self.editorInstance) {
          self.editorInstance.setData(msg);
        } else {
          // Wait for editor init
          setTimeout(function () {
            if (self.editorInstance) {
              self.editorInstance.setData(msg);
            }
          }, 2500);
        }
      } catch (err) {
        console.log('loadClient error:', err);
      }
    },

    async loadPowerUsers() {
      try {
        var res = await service.get('employee/getPowerUsers', {
          'Authorization': this.userToken,
          'cs3-context-role': this.userRole,
          'cs3-context-clientId': this.userClientID
        });
        this.powerUsers = res.data.result || [];
      } catch (err) {
        console.log('loadPowerUsers error:', err);
      }
    },

    async saveMessage() {
      if (!this.editorInstance) return;
      var self = this;
      self.saving = true;
      var html = self.editorInstance.getData();

      try {
        // Save via ownerOptions (same endpoint used by configOwnerOption)
        await service.post('employee/ownerOptions', {
          client_id: self.userClientID,
          login_page_message: html
        }, {
          'Authorization': self.userToken
        });

        self.previewHtml = html;
        self.$notify.success({
          title: 'Success',
          message: 'Splash message saved'
        });
      } catch (err) {
        console.log('saveMessage error:', err);
        self.$notify.error({
          title: 'Error',
          message: 'Failed to save splash message'
        });
      }
      self.saving = false;
    },

    async saveEditors() {
      try {
        await service.post('client/' + this.userClientID + '/saveClientSettings', {
          key: 'splash-editors',
          value: this.selectedEditors
        }, {
          'Authorization': this.userToken,
          'cs3-context-clientId': this.userClientID,
          'cs3-context-role': this.userRole
        });
        this.$notify.success({
          title: 'Success',
          message: 'Editor access updated'
        });
      } catch (err) {
        console.log('saveEditors error:', err);
        this.$notify.error({
          title: 'Error',
          message: 'Failed to update editor access'
        });
      }
    },

    initEditor() {
      var self = this;
      setTimeout(function () {
        self.editorInstance = CKEDITOR.replace('splash-editor', {
          height: '45vh',
          linkDefaultProtocol: 'https://',
          linkShowTargetTab: true,
          contentsCss: [CKEDITOR.basePath + 'contents.css', 'body { color: #ffffff; background: #335479; } a { color: #f1c40f !important; }'],
          on: {
            instanceReady: function (evt) {
              // Default links to new window
              evt.editor.on('dialogShow', function (e) {
                var dialog = e.data;
                if (dialog.getName() === 'link') {
                  var targetTab = dialog.getContentElement('target', 'linkTargetType');
                  if (targetTab && !dialog.getValueOf('target', 'linkTargetType')) {
                    dialog.setValueOf('target', 'linkTargetType', '_blank');
                  }
                }
              });

              // Update preview on changes
              evt.editor.on('change', function () {
                self.previewHtml = evt.editor.getData();
              });

              // Load content if client already loaded
              if (self.client && self.client.login_page_message) {
                evt.editor.setData(self.client.login_page_message);
              }
            }
          }
        });
      }, 500);
    }
  },

  async created() {
    await this.loadClient();
    if (this.userRoleSlug === 'client-admin') {
      await this.loadPowerUsers();
    }
  },

  mounted() {
    this.initEditor();
  },

  beforeDestroy() {
    if (this.editorInstance) {
      try { this.editorInstance.destroy(); } catch (e) { /* noop */ }
    }
  }
};
</script>

<style scoped>
.splash-preview {
  background: #335479;
  color: #fff;
  border-radius: 4px;
  padding: 20px;
  min-height: 80px;
  border: 1px solid #466D98;
}
.splash-preview a {
  color: #f1c40f;
}
</style>
